
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { ComparativeSampleDataMixin } from '@/mixins/ComparativeSampleDataMixin';
import { ComparativeDataPageState } from '@/models/pageStates/ComparativeDataPageState';
import { BAIconsMixin } from '@/mixins';
import { RegisterForAssessmentMixin } from '@/mixins/RegisterForAssessmentMixin';

@Component
export default class ComparativeDataNoComparisonAlert extends Mixins(
	ComparativeSampleDataMixin,
	RegisterForAssessmentMixin,
	BAIconsMixin
) {
	@Prop({ required: true }) state: ComparativeDataPageState;
	get ShowAlert(): boolean{
		return (this.state.IsNotEnoughData || this.state.IsNoAssessment) && !this.useSampleData;
	}
}
